import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import DashboardPage from "@/pages/DashboardPage";
import HomePage from "@/pages/HomePage";
import ArchivePage from "@/pages/ArchivePage";
import OutlookPage from "@/pages/OutlookPage";
import CriteriaPage from "@/pages/CriteriaPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminEditOutlook from "@/pages/AdminEditOutlook";
import ProtectedAdminRoute from "@/components/ProtectedAdminRoute";
import NamedStormsPage from "@/pages/NamedStormsPage";
import SeasonDetailPage from "@/pages/storms/SeasonDetailPage";
import LAIv1Page from "@/pages/LAIv1Page";

// Scroll to the top of the page on every navigation event.
// This is important on mobile where users are typically scrolled
// partway down and expect each new page to start at the top.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#1a1a1a]">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<DashboardPage />} />
            <Route path="home" element={<DashboardPage />} />
            <Route path="outlook" element={<HomePage />} />
            <Route path="archive" element={<ArchivePage />} />
            <Route path="outlook/:date" element={<OutlookPage />} />
            <Route path="criteria" element={<CriteriaPage />} />
            <Route path="storms" element={<NamedStormsPage />} />
            <Route path="storms/:tab" element={<NamedStormsPage />} />
            <Route path="storms/seasons/:season" element={<NamedStormsPage />} />
            <Route path="storms/seasons/:season/:stormName" element={<NamedStormsPage />} />
            <Route
              path="storms/season/:season"
              element={<SeasonDetailPage standalone />}
            />
            <Route path="lai-v1" element={<LAIv1Page />} />
          </Route>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute>
                <AdminDashboard />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/outlook/new"
            element={
              <ProtectedAdminRoute>
                <AdminEditOutlook />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/admin/outlook/:id"
            element={
              <ProtectedAdminRoute>
                <AdminEditOutlook />
              </ProtectedAdminRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;

